export default theme => ({
  blockContainer: {
    height: '100%',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.grey.light,
    minWidth: '1400px',
    padding: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      position: 'relative',
      height: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    top: 0,
    left: 0,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bgImg: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    width: '40%',
    background: `no-repeat url(${theme.url('/blocks/b1-bg-home-1.png')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'right',
  },
  content: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    maxWidth: '100%',
    height: '100%',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      position: 'initial',
    },
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      display: 'block',
      padding: 0,
    },
  },
  logo: {
    position: 'relative',
    top: -20,
    maxWidth: 80,
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: '5%',
      left: '5%',
    },
  },
  btn: {
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      bottom: 0,
      right: '5%',
    },
  },
  main: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& img': {
      width: 'auto',
      height: '70vh',
      maxHeight: '70vh',
      maxWidth: '70vw',
      objectFit: 'contain',
    },
  },
});
